<template>
  <div class="warp">
    <div class="align-right" style="padding-bottom:20px">
      <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="handlerLink">
        返回
      </el-button>
    </div>
    <div class="list-item">
      <div class="text">
        <div class="top">
          <span class="title">开学第一课.ppt </span> <span class="right">5星(50人评论)</span>
        </div>
        <div class="dec">
          <span>贡献者：童媛媛</span><span>学校：武汉市洪山区武路路实验小学</span><span>上传时间：2018-12-08</span><span>大小：19MB</span>
          <p class="view">
            <span>58人浏览</span><span>33下载</span><span>收藏：1</span>
          </p>
        </div>
      </div>
      <div class="imgbox">
        <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
      </div>
    </div>

    <div class="operating">
      <span class="right"><i class="el-icon-download" />下载</span><span class="right"><i class="el-icon-star-off" />收藏</span><span class="right"><i class="el-icon-circle-plus-outline" />添加</span>
    </div>
    <div>
      <el-tabs v-model="activeNameTabs">
        <el-tab-pane label="资源介绍" name="one">
          资源介绍
        </el-tab-pane>
        <el-tab-pane label="全部评价（12345条）" name="two">
          全部评价
        </el-tab-pane>
        <el-tab-pane label="我的评价" name="three">
          我的评价
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ResouresDetail',
  props: {
    propsObj: {
      default: Object,
      type: Object
    }
  },
  data: () => {
    return {
      activeNameTabs: 'one'
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    handlerLink() {
      this.$router.push('/' + this.propsObj.link + '/' + this.propsObj.propsId);
    }
  }
};
</script>
<style scoped lang="scss">
  .list-item {
    .text {
      line-height: 30px;
      .top {
        .title{
         font-size: 16px;
         font-weight: bold;
        }
      }
      .dec{
        span{
          margin-right: 20px;
        }
        .view{
          float: right;
          span{
              margin-right: 0;
              margin-left:20px ;
          }

        }
      }
    }
    .imgbox{
      width: 100%;
      height: 520px;
      border: 1px solid #ccc;
      margin: 20px 0;
    }
  }
   .operating{
      padding-bottom: 20px;
      span{
        margin-left: 20px;
      }
    }

</style>

